export default __webpack_public_path__ + "static/media/package.c7df178e.svg";